import { ApiUrls } from '@api/apiUrls';
import { fetchApi, FetchApiResponse } from 'api/fetchApi';
import { IApiDynamicDropdownViewResponse } from 'api/interfaces/data-contracts';

export const apiTradingAccountTypeCategoryUserService = {
  getCommissionList: async (): Promise<FetchApiResponse<IApiDynamicDropdownViewResponse[]>> => {
    return await fetchApi.get<IApiDynamicDropdownViewResponse[]>(
      ApiUrls.tradingAccountTypeCategoryUser.getCommissionList,
    );
  },
  getList: async (): Promise<FetchApiResponse<IApiDynamicDropdownViewResponse[]>> => {
    return await fetchApi.get<IApiDynamicDropdownViewResponse[]>(ApiUrls.tradingAccountTypeCategoryUser.getList);
  },
};
